<template>
    <div class="r-auth-register-company container">
        <h2>Create account</h2>
        <div class="row justify-content-center">
            <form
                class="col-lg-7"
                @submit.prevent="handleSubmit"
            >
                <h4 class="mt-4 mb-4">Comment</h4>

                <base-text-area
                    name="comment"
                    label="Add comment"
                    v-model="comment"
                    :inline="false" height="200px"
                    v-validate="'required|min:7'"
                    :err="errors.collect('comment')"
                />


                <div class="row mt-4">
                    <div class="col-6 text-left">
                        <base-button
                            radius="bl"
                            component-class="blue"
                            @click.native="$router.push({ name: 'auth-register' })"
                        ><i class="fas fa-arrow-left mr-3"></i> Previous
                        </base-button>
                    </div>
                    <div class="col-6 text-right">
                        <base-button
                            radius="br"
                            component-class="green filled"
                            type="submit"
                        > Register <i class="fas fa-arrow-right ml-3"></i>
                        </base-button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import BaseButton from '@/components/inputs/button/BaseButton';
    import BaseTextArea from '@/components/inputs/text/BaseTextArea';


    export default {
        data() {
            return {
                comment: '',
            };
        },

        computed: {
            ...mapState({
                authData: state => state.auth ? state.auth.data : {},
            }),
        },

        methods: {
            async handleSubmit() {
                try {
                    const isValidForm = await this.$validator.validateAll();
                    if (isValidForm) {
                        const { role, name, email, password, is_input } = this.authData;

                        const credentials = {
                            role_id: role.value,
                            name,
                            email,
                            password,
                            comment: this.comment,
                            is_input,
                        };

                        this.$store.dispatch('auth/register', credentials);
                        this.$router.push({ name: 'auth-login'});
                    }
                } catch (error) {
                    console.error(error);
                }
            },
        },

        mounted() {
            if (Object.keys(this.authData).length === 0) {
                this.$router.push({ name: 'auth-register'});
            }
        },

        components: {
            'base-button': BaseButton,
            'base-text-area': BaseTextArea,
        }
    };
</script>
